<div
	id="kt_invite_user"
	class="bg-body"
	data-kt-drawer="true"
	data-kt-drawer-name="create_company_role"
	data-kt-drawer-activate="true"
	data-kt-drawer-overlay="true"
	data-kt-drawer-width="{default:'100%', 'lg': '900px'}"
	data-kt-drawer-direction="end"
	data-kt-drawer-toggle="#kt_invite_user_toggle"
	data-kt-drawer-close="#kt_invite_user_close"
>
	<!-- Drawer content -->

	<div class="card shadow-none rounded-0 w-100">
		<div class="card-header" id="kt_invite_user_header">
			<h3 class="card-title fw-bolder text-gray-900" translate>invite_user_drawer_title</h3>
			<span class="text-muted fs-7 fw-semibold" translate>invite_user_drawer_description</span>
		</div>
		<div class="card-body position-relative" id="kt_invite_user_body">
			<div
				id="kt_invite_user_scroll"
				class="position-relative scroll-y me-n5 pe-5"
				data-kt-scroll="true"
				data-kt-scroll-height="auto"
				data-kt-scroll-wrappers="#kt_invite_user_body"
				data-kt-scroll-dependencies="#kt_invite_user_header, #kt_invite_user_footer"
				data-kt-scroll-offset="0px"
			>
				<div>
					<!-- Role form fields will go here -->
					<div class="fv-row mb-7">
						<label class="required fw-semibold fs-6 mb-2" translate>invite_user_drawer_email</label>
						<input
							type="text"
							class="form-control form-control-solid mb-3 mb-lg-0"
							[(ngModel)]="userEmail"
							(input)="validateRoleName()"
							placeholder="{{ 'invite_user_drawer_email_placeholder' | translate }}"
						/>
						@if (userEmailError) {
							<div class="fv-plugins-message-container invalid-feedback">
								{{ 'invite_user_email_error' | translate }}
							</div>
						}
					</div>

					<div class="fv-row mb-7">
						<label class="required fw-semibold fs-6 mb-2" translate>invite_user_drawer_role</label>
						<app-select
							[options]="roles$ | async"
							[placeholder]="'select_role_placeholder' | translate"
							[selectedOption]="this.userRoler$ | async"
							(selectItemChange)="onRoleChange($event)"
						></app-select>
					</div>
				</div>
			</div>
		</div>
		<div class="card-footer py-5 d-flex justify-content-between align-items-center" id="kt_invite_user_footer">
			<button id="kt_invite_user_close" type="button" class="hover-elevate-up btn btn-light d-flex justify-content-between round py-4">
				<app-keenicon name="to-left" class="fs-3 text-muted me-3"></app-keenicon>
				<span class="text-muted font-size-sm" translate>drawer_back</span>
			</button>
			<button type="button" class="hover-elevate-up btn btn-primary d-flex justify-content-between round py-4" (click)="inviteUser()">
				<span class="text-white font-size-sm me-2" [translate]="'send_invitation'"></span>
				<app-keenicon name="rocket" class="fs-3 text-white"></app-keenicon>
			</button>
		</div>
	</div>
</div>
